import { createAction, props } from '@ngrx/store';

import { BpasEngagement } from '../../domain/bpas-engagement.model';

export const PAC_LOAD_ENGAGEMENTS_SUCCEEDED = '[Engagements API] Load Engagements Succeeded';
export const PAC_LOAD_ENGAGEMENTS_FAILED = '[Engagements API] Load Engagements Failed';
export const PAC_UPDATE_ENGAGEMENTS_SUCCEEDED = '[Engagements API] Update Engagements Succeeded';
export const PAC_CLOSE_ENGAGEMENTS_SUCCEEDED = '[Engagements API] Close Engagements Succeeded';
export const PAC_OPEN_NEW_ENGAGEMENT_SUCCEEDED = '[Engagements API] Open New Engagement Succeeded';
export const PAC_UPDATE_ENGAGEMENTS_FAILED = '[Engagements API] Update Engagements Failed';
export const PAC_REMOVE_PORTFOLIO_FROM_ENGAGEMENT_FAILED = '[Engagements API] Remove Portfolio From Engagement Failed';

export const loadEngagementsSucceeded = createAction(
	PAC_LOAD_ENGAGEMENTS_SUCCEEDED,
	props<{ engagements: BpasEngagement[] }>()
);

export const loadEngagementsFailed = createAction(
	PAC_LOAD_ENGAGEMENTS_FAILED,
	props<{ errorCode: string }>()
);

export const updateEngagementsSucceeded = createAction(
	PAC_UPDATE_ENGAGEMENTS_SUCCEEDED,
	props<{ engagements: BpasEngagement[]; updateAnalysis: boolean }>()
);

export const closeEngagementsSucceeded = createAction(
	PAC_CLOSE_ENGAGEMENTS_SUCCEEDED,
	props<{ engagements: BpasEngagement[] }>()
);

export const openNewEngagementSucceeded = createAction(
	PAC_OPEN_NEW_ENGAGEMENT_SUCCEEDED,
	props<{ engagement: BpasEngagement }>()
);

export const updateEngagementsFailed = createAction(
	PAC_UPDATE_ENGAGEMENTS_FAILED,
	props<{ errorCode: string }>()
);

export const removePortfolioFromEngagementFailed = createAction(
	PAC_REMOVE_PORTFOLIO_FROM_ENGAGEMENT_FAILED,
	props<{ errorCode: string }>()
);
